import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import clsx from 'clsx';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import { Button, Modal } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import MenuDrawerGroup from '../../components/MenuDrawerGroup';
import SearchButton from '../../components/atoms/SearchButton';
// import ESSearchButton from '../../components/atoms/ESSearchButton';
import CsvDownloadButton from '../../components/atoms/CsvDownloadButton';
// import CsvDownloadEsButton from '../../components/atoms/CsvDownloadEsButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import GochiHistoryTableGroup from '../organisms/GochiHistoryTableGroup';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';
import DownloadCsvDialogConfirm from '../../components/molecules/DownloadCsvDialogConfirm';
import {
  getGochis,
  downloadGochi,
  getGochisEs,
  downloadGochiEs,
  getGochiGroupCampaign,
  downloadGochiGroupCampaign,
  updateAmountEducationSystem,
  getUpdateAmountHistoryDetail,
  getRemainAmountUpdateAmount,
  UPDATE_AMOUNT_EDUCATION_SYSTEM_SUCCESS,
  GET_UPDATE_AMOUNT_HISTORY_DETAIL_SUCCESS,
  GET_REMAIN_AMOUNT_UPDATE_AMOUNT_SUCCESS,
  getGochiGroupGochiKid,
  downloadGochiGroupGochiKid
} from '../../actions/Gochis';
import depositPlans from '../../constants/DepositPlan';
import { getTextBySystem as gts } from '../../utils';
import UpdateAmountModal from '../organisms/UpdateAmountModal';
import UpdateAmountConfirmModal from '../organisms/UpdateAmountConfirmModal';
import UpdateAmountSuccessModal from '../organisms/UpdateAmountSuccessModal';
import UpdateAmountHistoryModal from '../organisms/UpdateAmountHistoryModal';

const drawerWidth = 240;

const styles = theme => ({
  root: {
    display: 'flex'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginRight: 36
  },
  hide: {
    display: 'none'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap'
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1
    }
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar
  },
  content: {
    flexGrow: 1,
    padding: 40,
    paddingTop: 15,
    width: 'calc(100% - 240px)'
  },
  // end sidebar
  paperWhite: {
    padding: 20,
    marginBottom: 40
  },
  title: {
    color: '#000',
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 15
  },
  subTitle: {
    fontWeight: '600',
    fontSize: 12,
    marginBottom: 10,
    color: '#000000'
  },
  rowForm: {
    display: 'flex',
    marginLeft: '-5px',
    marginRight: '-5px',
    flexWrap: 'wrap'
  },
  formControl: {
    paddingLeft: 5,
    paddingRight: 5,
    marginBottom: 15,
    width: '20%'
  },
  formControlFukuoka: {
    paddingLeft: 5,
    paddingRight: 5,
    marginBottom: 15,
    width: '25%'
  },
  textField: {
    position: 'relative'
  },
  pageNButton: {
    display: 'flex',
    marginRight: '-5px',
    alignItems: 'center'
  },
  buttonRight: {
    marginLeft: 'auto'
  },
  textNoteClassicCsv: {
    fontSize: 12,
    width: 220,
    marginLeft: 'auto',
    textAlign: 'left',
    marginBottom: 10
  },
  textLinkCsv: {
    color: '#2196F3'
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      gochis: state.gochis,
      account: state.accounts.account,
      gochiTypes: state.gochis.gochiTypes.map(el =>
        el.id === '' ? { ...el, name: '選択してください' } : el
      ),
      gochiUserTypes: state.gochis.gochiUserTypes.map(el =>
        el.id === '' ? { ...el, name: '選択してください' } : el
      ),
      gochiStatuses: state.gochis.gochiStatuses.map(el =>
        el.id === '' ? { ...el, name: '選択してください' } : el
      )
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochis,
          downloadGochi,
          getGochisEs,
          downloadGochiEs,
          getGochiGroupCampaign,
          downloadGochiGroupCampaign,
          updateAmountEducationSystem,
          getUpdateAmountHistoryDetail,
          getRemainAmountUpdateAmount,
          getGochiGroupGochiKid,
          downloadGochiGroupGochiKid
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openModal', 'updateOpenModal', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('groupName', 'setGroupName', ''),
  withState('shopName', 'setShopName', ''),
  withState('menuId', 'setMenuId', ''),
  withState('address', 'setAddress', ''),
  withState('menuName', 'setMenuName', ''),
  withState('userName', 'setUserName', ''),
  withState('gochiType', 'setGochiType', ''),
  withState('gochiUserType', 'setGochiUserType', ''),
  withState('isShashoku', 'setIsShashoku', ''),
  withState('isGochiKid', 'setIsGochiKid', ''),
  withState('gochiDateFrom', 'setGochiDateFrom', () => {
    moment.tz.setDefault('Asia/Tokyo');
    return moment()
      .date(1)
      .format('YYYY-MM-DD');
  }),
  withState('gochiDateTo', 'setGochiDateTo', () => {
    return moment()
      .endOf('month')
      .format('YYYY-MM-DD');
  }),
  withState('gochiStatus', 'setGochiStatus', ''),
  withState('gochiUseDateFrom', 'setGochiUseDateFrom', ''),
  withState('gochiUseDateTo', 'setGochiUseDateTo', ''),
  withState('gochiUseDateEnableFlg', 'setGochiUseDateEnableFlg', true),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 20),
  withState('shopId', 'setShopId', ''),
  withState('gochiBillNo', 'setGochiBillNo', ''),
  withState('searchEs', 'setSearchEs', false),
  withState('depositPlan', 'setDepositPlan', ''),
  withState('openPopupCsv', 'setOpenPopupCsv', false),
  withState('openPopupESCsv', 'setOpenPopupESCsv', false),
  withState('isZip', 'setIsZip', false),
  withState('showUpdateAmountModal', 'setShowUpdateAmountModal', false),
  withState(
    'showUpdateAmountConfirmModal',
    'setShowUpdateAmountConfirmModal',
    false
  ),
  withState(
    'showUpdateAmountSuccessModal',
    'setShowUpdateAmountSuccessModal',
    false
  ),
  withState('gochiChoseUpdateAmount', 'setGochiChoseUpdateAmount', null),
  withState(
    'couponGochiChoseUpdateAmount',
    'setCouponGochiChoseUpdateAmount',
    null
  ),
  withState(
    'systemNameGochiChoseUpdateAmount',
    'setSystemNameGochiChoseUpdateAmount',
    ''
  ),
  withState('oldAmountUpdateAmount', 'setOldAmountUpdateAmount', null),
  withState('maxAmountCanUpdate', 'setMaxAmountCanUpdate', 0),
  withState('amountUpdated', 'setAmountUpdated', null),
  withState('amountUpdatedError', 'setAmountUpdatedError', ''),
  withState('crfsToken', 'setCrfsToken', ''),
  withState(
    'showUpdateAmountHistoryModal',
    'setShowUpdateAmountHistoryModal',
    false
  ),
  withState('updateAmountHistoryDetail', 'setUpdateAmountHistoryDetail', null),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangeRowsPerPage: props => event => {
      props.setRowsPerPage(event.target.value);
    },
    handleChangePage: props => (event, page, limit, isSearchEs) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      // if (props.searchEs) {
      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 20;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }
      const searchKey = {
        groupName: props.groupName,
        shopName: props.shopName,
        address: props.address,
        menuName: props.menuName,
        userName: props.userName,
        gochiType: props.gochiType,
        gochiUserType: props.gochiUserType,
        gochiDateFrom: props.gochiDateFrom,
        gochiDateTo: props.gochiDateTo,
        gochiStatus: props.gochiStatus,
        gochiUseDateFrom: props.gochiUseDateFrom,
        gochiUseDateTo: props.gochiUseDateTo,
        gochiBillNo: props.gochiBillNo,
        shopId: props.shopId,
        menuId: props.menuId,
        depositPlan: props.depositPlan,
        page,
        limit: limit || limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      if (isSearchEs) {
        props.actions
          .getGochisEs(searchKey)
          .then(data => {
            // props.checkSession(data);
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            if (data.type === 'GET_GOCHIS_SUCCESS') {
              props.updateOpenProgress(false);
              props.setResultMessage('');
              props.updateLoading(false);
              props.updateOpenTable(true);
            } else {
              props.setResultMessage('ごち検索に失敗しました。');
              props.updateLoading(false);
            }
          })
          .catch(e => {
            console.log('error search ES', e);
            props.updateOpenProgress(true);
            props.setResultMessage('ごち検索に失敗しました。');
            props.updateLoading(false);
          });
      } else if (
        (props.account.groupType === 'CAMPAIGN' ||
          props.account.groupType === 'OTHERS') &&
        props.account.fukuokaFlag !== 1
      ) {
        props.actions
          .getGochiGroupCampaign(searchKey)
          .then(data => {
            // props.checkSession(data);
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            if (data.type === 'GET_GOCHIS_SUCCESS') {
              props.updateOpenProgress(false);
              props.setResultMessage('');
              props.updateLoading(false);
              props.updateOpenTable(true);
            } else {
              props.setResultMessage('ごち検索に失敗しました。');
              props.updateLoading(false);
            }
          })
          .catch(e => {
            console.log('error search gochi', e);
            props.updateOpenProgress(true);
            props.setResultMessage('ごち検索に失敗しました。');
            props.updateLoading(false);
          });
      } else if (
        props.account.groupType === 'GOCHI_KID' &&
        props.account.fukuokaFlag !== 1
      ) {
        searchKey.gochiDateFrom = '';
        searchKey.gochiDateTo = '';
        props.actions
          .getGochiGroupGochiKid(searchKey)
          .then(data => {
            // props.checkSession(data);
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            if (data.type === 'GET_GOCHIS_SUCCESS') {
              props.updateOpenProgress(false);
              props.setResultMessage('');
              props.updateLoading(false);
              props.updateOpenTable(true);
            } else {
              props.setResultMessage('ごち検索に失敗しました。');
              props.updateLoading(false);
            }
          })
          .catch(e => {
            console.log('error search gochi', e);
            props.updateOpenProgress(true);
            props.setResultMessage('ごち検索に失敗しました。');
            props.updateLoading(false);
          });
      } else {
        props.actions
          .getGochis(searchKey)
          .then(data => {
            // props.checkSession(data);
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            if (data.type === 'GET_GOCHIS_SUCCESS') {
              props.updateOpenProgress(false);
              props.setResultMessage('');
              props.updateLoading(false);
              props.updateOpenTable(true);
            } else {
              props.setResultMessage('ごち検索に失敗しました。');
              props.updateLoading(false);
            }
          })
          .catch(e => {
            console.log('error search gochi', e);
            props.updateOpenProgress(true);
            props.setResultMessage('ごち検索に失敗しました。');
            props.updateLoading(false);
          });
      }
      // }
      props.setPage(page);
    },
    generateRandomString: props => (length = 32) => {
      let text = '';
      const possible =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

      for (let i = 0; i < length; i += 1) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }

      console.log('crfs token', text);
      props.setCrfsToken(text);
      return text;
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.generateRandomString();
      this.props.handleChangePage(null, 1, this.props.rowsPerPage, false);
    }
  })
);

const HomeGroup = enhance(
  ({
    classes,
    actions,
    checkSession,
    handleChangePage,
    handleChangeRowsPerPage,
    gochis,
    account,
    gochiTypes,
    gochiUserTypes,
    gochiStatuses,
    openTable,
    // updateOpenTable,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    setResultMessage,
    groupName,
    shopName,
    setShopName,
    address,
    setAddress,
    menuName,
    setMenuName,
    userName,
    setUserName,
    gochiType,
    setGochiType,
    gochiBillNo,
    setGochiBillNo,
    gochiUserType,
    setGochiUserType,
    gochiDateFrom,
    setGochiDateFrom,
    gochiDateTo,
    setGochiDateTo,
    gochiStatus,
    setGochiStatus,
    gochiUseDateFrom,
    setGochiUseDateFrom,
    gochiUseDateTo,
    setGochiUseDateTo,
    gochiUseDateEnableFlg,
    setGochiUseDateEnableFlg,
    page,
    shopId,
    setShopId,
    menuId,
    setMenuId,
    searchEs,
    setSearchEs,
    setPage,
    isShashoku,
    setIsShashoku,
    setRowsPerPage,
    depositPlan,
    setDepositPlan,
    openPopupCsv,
    setOpenPopupCsv,
    openPopupESCsv,
    setOpenPopupESCsv,
    isZip,
    setIsZip,
    isGochiKid,
    setIsGochiKid,
    showUpdateAmountModal,
    setShowUpdateAmountModal,
    gochiChoseUpdateAmount,
    setGochiChoseUpdateAmount,
    couponGochiChoseUpdateAmount,
    setCouponGochiChoseUpdateAmount,
    systemNameGochiChoseUpdateAmount,
    setSystemNameGochiChoseUpdateAmount,
    oldAmountUpdateAmount,
    setOldAmountUpdateAmount,
    maxAmountCanUpdate,
    setMaxAmountCanUpdate,
    amountUpdated,
    setAmountUpdated,
    amountUpdatedError,
    setAmountUpdatedError,
    showUpdateAmountConfirmModal,
    setShowUpdateAmountConfirmModal,
    showUpdateAmountSuccessModal,
    setShowUpdateAmountSuccessModal,
    crfsToken,
    generateRandomString,
    showUpdateAmountHistoryModal,
    setShowUpdateAmountHistoryModal,
    updateAmountHistoryDetail,
    setUpdateAmountHistoryDetail,
    history
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isDeveloper =
      typeof account !== 'undefined' && account.role === 'DEVELOPER';
    const isFukuoka =
      typeof account !== 'undefined' && account.fukuokaFlag === 1;
    const isNaha = typeof account !== 'undefined' && account.nahaFlag === 1;
    const educateSystem =
      typeof account !== 'undefined' && account.educateSystem;
    const isGochiKidGroup = isGroup && account.groupType === 'GOCHI_KID';
    const roles = {
      isShop,
      isGroup,
      isSecretariat,
      isDeveloper
    };

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limit = 20;
    if (rowsPerPage) {
      limit = rowsPerPage.textContent;
    }

    const searchKey = {
      groupName,
      shopName,
      address,
      menuName,
      userName,
      gochiType,
      gochiUserType,
      gochiDateFrom,
      gochiDateTo,
      gochiStatus,
      gochiUseDateFrom,
      gochiUseDateTo,
      gochiBillNo,
      shopId,
      menuId,
      depositPlan,
      limit
    };

    let limitNum = 20;
    if (rowsPerPage) {
      limitNum = rowsPerPage.textContent;
    }

    const searchAction = async () => {
      setSearchEs(false);
      updateLoading(true);
      updateOpenProgress(true);
      setPage(1);
      handleChangePage(null, 1, limitNum, false);
    };

    // const searchEsAction = async () => {
    //   updateLoading(true);
    //   updateOpenProgress(true);
    //   await actions
    //     .getGochisEs(searchKey)
    //     .then(data => {
    //       checkSession(data);
    //       if (data.type === 'GET_GOCHIS_SUCCESS') {
    //         updateOpenProgress(false);
    //         setResultMessage('');
    //         updateLoading(false);
    //         // handleChangePage(null, 0);
    //         updateOpenTable(true);
    //         setSearchEs(true);
    //       } else {
    //         setResultMessage('ごち検索に失敗しました。');
    //         updateLoading(false);
    //       }
    //     })
    //     .catch(() => {
    //       updateOpenProgress(true);
    //       setResultMessage('ごち検索に失敗しました。');
    //       updateLoading(false);
    //     });
    // };

    const downloadCsvBlob = (blob, fileName, isZipP) => {
      const blobC = new Blob([blob], {
        type: isZipP ? 'application/zip' : 'text/csv'
      });
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(blobC, fileName);
      } else {
        // for chrome, firefox
        const url = URL.createObjectURL(blobC);
        const linkEl = document.createElement('a');
        linkEl.href = url;
        linkEl.setAttribute('download', fileName);
        document.body.appendChild(linkEl);
        linkEl.click();

        linkEl.parentNode.removeChild(linkEl);
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      }
    };

    const csvDownloadAction = async isZipP => {
      updateLoading(true);
      updateOpenProgress(true);
      let fileType = '';
      const params = { ...searchKey };
      if (isZipP) {
        params.isZip = 1;
        fileType = '.csv.zip';
      } else {
        params.isZip = 0;
        fileType = '.csv';
      }
      let response = null;
      if (
        (account.groupType === 'CAMPAIGN' || account.groupType === 'OTHERS') &&
        account.fukuokaFlag !== 1
      ) {
        response = await actions
          .downloadGochiGroupCampaign(params)
          .then(data => checkSession(data));
      } else if (
        account.groupType === 'GOCHI_KID' &&
        account.fukuokaFlag !== 1
      ) {
        response = await actions
          .downloadGochiGroupGochiKid(params)
          .then(data => checkSession(data));
      } else {
        response = await actions
          .downloadGochi(params)
          .then(data => checkSession(data));
      }
      if (response.type === 'DOWNLOAD_GOCHIS_SUCCESS') {
        const timeStamp = moment()
          .tz('Asia/Tokyo')
          .format('YYYYMMDDHHmm');
        updateOpenProgress(false);
        setResultMessage('');
        updateLoading(false);
        const csvName = !isFukuoka ? '_gochi_info' : '_coupon_info';
        downloadCsvBlob(
          response.payload,
          `${timeStamp}${csvName}${fileType}`,
          isZipP
        );
      } else {
        setResultMessage(
          'ファイル容量が想定量を超えたため、ダウンロードに失敗しました。\n恐れ入りますが、期間を短く設定し直してから再度ダウンロードを実行ください。'
        );
        updateLoading(false);
      }
    };

    // const csvDownloadEsAction = async () => {
    //   updateLoading(true);
    //   updateOpenProgress(true);
    //   const response = await actions
    //     .downloadGochiEs(searchKey)
    //     .then(data => checkSession(data));
    //   if (response.type === 'DOWNLOAD_GOCHIS_ES_SUCCESS') {
    //     const timeStamp = moment()
    //       .tz('Asia/Tokyo')
    //       .format('YYYYMMDDHHmm');
    //     updateOpenProgress(false);
    //     setResultMessage('');
    //     updateLoading(false);
    //     downloadCsvBlob(response.payload, `${timeStamp}_gochi_info.csv`);
    //   } else {
    //     setResultMessage('ごち情報ダウンロードに失敗しました。');
    //     updateLoading(false);
    //   }
    // };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    const handleChangeGochiType = e => {
      setGochiType(e);
      if (e === 'SHASHOKU') {
        setIsShashoku(true);
        setGochiDateFrom('');
        setGochiDateTo('');
        setGochiUserType('');
        setGochiBillNo('');
      } else if (e === 'GOCHI_KID') {
        setIsGochiKid(true);
        setGochiDateFrom('');
        setGochiDateTo('');
        setGochiUserType('');
        setGochiBillNo('');
      } else {
        setIsShashoku(false);
        setIsGochiKid(false);
        setGochiDateFrom(() => {
          moment.tz.setDefault('Asia/Tokyo');
          return moment()
            .date(1)
            .format('YYYY-MM-DD');
        });
        setGochiDateTo(() => {
          return moment()
            .endOf('month')
            .format('YYYY-MM-DD');
        });
      }
    };

    const cancelCsvAction = () => {
      setOpenPopupCsv(false);
      setIsZip(false);
    };

    const downloadCsvAction = () => {
      setOpenPopupCsv(false);
      csvDownloadAction(isZip);
    };

    const cancelESCsvAction = () => {
      setOpenPopupESCsv(false);
    };

    // const downloadESCsvAction = () => {
    //   setOpenPopupESCsv(false);
    //   // csvDownloadEsAction();
    // };

    const openUpdateAmountModal = async (gochi, coupon) => {
      updateLoading(true);
      updateOpenProgress(true);
      let params = null;

      if (gochi.sourceTable === 'SHASHOKU') {
        params = {
          shashokuTicketId: gochi.shashokuTicketId,
          couponId: null
        };
      } else if (
        gochi.sourceTable === 'GOCHI' &&
        gochi.gochiTypeStr === gochiTypes[4].name
      ) {
        params = {
          shashokuTicketId: null,
          couponId: coupon.couponId
        };
      }

      const response = await actions
        .getRemainAmountUpdateAmount(params)
        .then(data => checkSession(data));

      if (response.type === GET_REMAIN_AMOUNT_UPDATE_AMOUNT_SUCCESS) {
        updateLoading(false);
        updateOpenProgress(false);
        setGochiChoseUpdateAmount(gochi);
        setAmountUpdatedError('');
        setSystemNameGochiChoseUpdateAmount(response.payload.eduSystem);

        if (gochi.sourceTable === 'SHASHOKU') {
          setCouponGochiChoseUpdateAmount(null);
          setOldAmountUpdateAmount(gochi.amountTransferToShopWhenUseShashoku);
          setMaxAmountCanUpdate(gochi.amountTransferToShopWhenUseShashoku);

          if (gochi.menuId) {
            setAmountUpdated(0);
            generateRandomString();
            setShowUpdateAmountConfirmModal(true);
          } else {
            setAmountUpdated(null);
            setShowUpdateAmountModal(true);
          }
        } else if (
          gochi.sourceTable === 'GOCHI' &&
          gochi.gochiTypeStr === gochiTypes[4].name
        ) {
          setAmountUpdated(null);
          setShowUpdateAmountModal(true);
          setCouponGochiChoseUpdateAmount(coupon);
          setOldAmountUpdateAmount(coupon.amountTransferToShopWhenUse);
          setMaxAmountCanUpdate(coupon.amountTransferToShopWhenUse);
        }
      } else {
        updateLoading(false);
        setResultMessage('エラーが発生しました！');
      }
    };

    const validAmountUpdated = () => {
      const value = amountUpdated;
      if (value === '') {
        setAmountUpdatedError('必須項目です。');
        return 1;
      }

      if (!/^\d+$/.test(value)) {
        setAmountUpdatedError('半角数字のみ入力してください。');
        return 1;
      }

      if (parseInt(value, 10) > maxAmountCanUpdate) {
        setAmountUpdatedError(
          '※現在のクーポン利用額（合計）以下の金額に編集してください。'
        );
        return 1;
      }

      if (parseInt(value, 10) === maxAmountCanUpdate) {
        setAmountUpdatedError('修正金額を正しく入力してください。');
        return 1;
      }

      setAmountUpdatedError('');
      setAmountUpdated(parseInt(value, 10));
      return 0;
    };

    const confirmUpdateAmount = () => {
      let errorCount = 0;
      errorCount = validAmountUpdated();

      if (errorCount === 0) {
        setShowUpdateAmountModal(false);
        generateRandomString();
        setShowUpdateAmountConfirmModal(true);
      }
    };

    const backConfirmUpdateAmount = () => {
      setShowUpdateAmountConfirmModal(false);

      if (
        (gochiChoseUpdateAmount.sourceTable === 'SHASHOKU' &&
          !gochiChoseUpdateAmount.menuId) ||
        (gochiChoseUpdateAmount.sourceTable === 'GOCHI' &&
          gochiChoseUpdateAmount.gochiTypeStr === gochiTypes[4].name)
      ) {
        setShowUpdateAmountModal(true);
      }
    };

    const editAmountEducationSystem = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      let params = null;

      if (gochiChoseUpdateAmount.sourceTable === 'SHASHOKU') {
        params = {
          shashokuTicketId: gochiChoseUpdateAmount.shashokuTicketId,
          couponId: null,
          newAmount: amountUpdated
        };
      } else if (
        gochiChoseUpdateAmount.sourceTable === 'GOCHI' &&
        gochiChoseUpdateAmount.gochiTypeStr === gochiTypes[4].name
      ) {
        params = {
          shashokuTicketId: null,
          couponId: couponGochiChoseUpdateAmount.couponId,
          newAmount: amountUpdated
        };
      }

      const response = await actions
        .updateAmountEducationSystem(params, crfsToken)
        .then(data => checkSession(data));

      if (response.type === UPDATE_AMOUNT_EDUCATION_SYSTEM_SUCCESS) {
        generateRandomString();
        setShowUpdateAmountSuccessModal(true);
        setShowUpdateAmountConfirmModal(false);
        updateLoading(false);
        updateOpenProgress(false);
      } else {
        updateLoading(false);
        if (
          response.error &&
          response.payload.data &&
          response.payload.data.errorInfo &&
          response.payload.data.errorInfo.code ===
            'exception.errors.security.has.csrf.token'
        ) {
          generateRandomString();
          setResultMessage('処理中ですのでしばらくお待ちください。');
        } else {
          setResultMessage('エラーが発生しました！');
        }
      }
    };

    const handleCloseUpdateAmountSuccessModal = () => {
      handleChangePage(null, page, null, false);
      setShowUpdateAmountSuccessModal(false);
    };

    const openUpdateAmountHistory = async (couponId, shashokuTicketId) => {
      updateLoading(true);
      updateOpenProgress(true);
      const response = await actions
        .getUpdateAmountHistoryDetail({ couponId, shashokuTicketId })
        .then(data => checkSession(data));

      if (response.type === GET_UPDATE_AMOUNT_HISTORY_DETAIL_SUCCESS) {
        setUpdateAmountHistoryDetail(response.payload);
        setShowUpdateAmountHistoryModal(true);
        updateLoading(false);
        updateOpenProgress(false);
      } else {
        updateLoading(false);
        setResultMessage('エラーが発生しました！');
      }
    };

    return (
      <div className={classes.root}>
        <MenuDrawerGroup title="ごち情報" />
        <main className={classes.content}>
          <div className={classes.toolbar} style={{ display: 'none' }} />

          <Typography variant="h6" noWrap className={classes.title}>
            {isFukuoka ? 'クーポン情報' : 'ごち情報'}
          </Typography>
          <Paper className={classes.paperWhite}>
            <div className={classes.searchForm}>
              <div className={classes.rowForm}>
                {!isGochiKidGroup && (
                  <FormControl
                    className={clsx(
                      classes.margin,
                      isFukuoka
                        ? classes.formControlFukuoka
                        : classes.formControl
                    )}
                    variant="outlined"
                    size="small"
                  >
                    <FormLabel className={classes.subTitle}>
                      {gts('領収書NO', educateSystem)}
                    </FormLabel>
                    <TextField
                      placeholder="例) 0123"
                      type="search"
                      className={classes.textField}
                      variant="outlined"
                      size="small"
                      disabled={isShashoku || isGochiKid}
                      value={gochiBillNo}
                      onChange={e => {
                        setGochiBillNo(e.target.value);
                      }}
                    />
                  </FormControl>
                )}

                <FormControl
                  className={clsx(
                    classes.margin,
                    isFukuoka ? classes.formControlFukuoka : classes.formControl
                  )}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>
                    {isFukuoka ? '教室ID' : '店舗ID'}
                  </FormLabel>
                  <TextField
                    placeholder="例) 0123"
                    type="search"
                    className={classes.textField}
                    variant="outlined"
                    size="small"
                    value={shopId}
                    onChange={e => {
                      setShopId(e.target.value);
                    }}
                  />
                </FormControl>

                <FormControl
                  className={clsx(
                    classes.margin,
                    isFukuoka ? classes.formControlFukuoka : classes.formControl
                  )}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>
                    {isFukuoka ? '教室名' : '店舗名'}
                  </FormLabel>
                  <TextField
                    placeholder={
                      isFukuoka ? '例) Gigi〇〇校' : '例) Gigi 〇〇店'
                    }
                    type="search"
                    className={classes.textField}
                    variant="outlined"
                    size="small"
                    value={shopName}
                    onChange={e => {
                      setShopName(e.target.value);
                    }}
                  />
                </FormControl>

                <FormControl
                  className={clsx(
                    classes.margin,
                    isFukuoka ? classes.formControlFukuoka : classes.formControl
                  )}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>住所</FormLabel>
                  <TextField
                    placeholder={gts('例) 東京都 1-2-3', educateSystem)}
                    type="search"
                    className={classes.textField}
                    variant="outlined"
                    size="small"
                    value={address}
                    onChange={e => {
                      setAddress(e.target.value);
                    }}
                  />
                </FormControl>

                {!isGochiKidGroup && (
                  <FormControl
                    className={clsx(
                      classes.margin,
                      isFukuoka
                        ? classes.formControlFukuoka
                        : classes.formControl
                    )}
                    variant="outlined"
                    size="small"
                  >
                    <FormLabel className={classes.subTitle}>
                      {gts('購入日 (From)', educateSystem)}
                    </FormLabel>
                    <TextField
                      type="date"
                      className={classes.textField150}
                      variant="outlined"
                      size="small"
                      InputLabelProps={{
                        shrink: true
                      }}
                      disabled={isShashoku || isGochiKid}
                      value={gochiDateFrom}
                      onChange={e => {
                        setGochiDateFrom(e.target.value);
                      }}
                    />
                  </FormControl>
                )}
                {!isGochiKidGroup && (
                  <FormControl
                    className={clsx(
                      classes.margin,
                      isFukuoka
                        ? classes.formControlFukuoka
                        : classes.formControl
                    )}
                    variant="outlined"
                    size="small"
                  >
                    <FormLabel className={classes.subTitle}>
                      {gts('購入日 (To)', educateSystem)}
                    </FormLabel>
                    <TextField
                      type="date"
                      className={classes.textField150}
                      variant="outlined"
                      size="small"
                      InputLabelProps={{
                        shrink: true
                      }}
                      disabled={isShashoku || isGochiKid}
                      value={gochiDateTo}
                      onChange={e => {
                        setGochiDateTo(e.target.value);
                      }}
                    />
                  </FormControl>
                )}

                <FormControl
                  className={clsx(
                    classes.margin,
                    isFukuoka ? classes.formControlFukuoka : classes.formControl
                  )}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>
                    {isFukuoka ? 'コースID' : 'メニューID'}
                  </FormLabel>
                  <TextField
                    placeholder="例) 0123"
                    type="search"
                    className={classes.textField}
                    variant="outlined"
                    size="small"
                    value={menuId}
                    onChange={e => {
                      setMenuId(e.target.value);
                    }}
                  />
                </FormControl>

                <FormControl
                  className={clsx(
                    classes.margin,
                    isFukuoka ? classes.formControlFukuoka : classes.formControl
                  )}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>
                    {isFukuoka ? 'コース名' : 'メニュー名'}
                  </FormLabel>
                  <TextField
                    placeholder={
                      isFukuoka ? '例) Gigi〇〇コース' : '例) とんかつ定食'
                    }
                    type="search"
                    className={classes.textField}
                    variant="outlined"
                    size="small"
                    value={menuName}
                    onChange={e => {
                      setMenuName(e.target.value);
                    }}
                  />
                </FormControl>

                {!isFukuoka && (
                  <>
                    {!isGochiKidGroup && (
                      <FormControl
                        className={clsx(classes.margin, classes.formControl)}
                        variant="outlined"
                        size="small"
                      >
                        <FormLabel className={classes.subTitle}>
                          チケット種別
                        </FormLabel>
                        <Select
                          className={classes.textField}
                          variant="outlined"
                          size="small"
                          value={gochiType}
                          onChange={e => {
                            handleChangeGochiType(e.target.value);
                          }}
                          InputLabelProps={{
                            shrink: true
                          }}
                          displayEmpty
                        >
                          {gochiTypes.map(type => {
                            return (
                              <MenuItem key={type.id} value={type.id}>
                                {type.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    )}

                    {!isGochiKidGroup && (
                      <FormControl
                        className={clsx(classes.margin, classes.formControl)}
                        variant="outlined"
                        size="small"
                      >
                        <FormLabel className={classes.subTitle}>
                          使用者種別
                        </FormLabel>
                        <Select
                          className={classes.textField}
                          variant="outlined"
                          size="small"
                          disabled={isShashoku || isGochiKid}
                          value={gochiUserType}
                          onChange={e => {
                            setGochiUserType(e.target.value);
                          }}
                          InputLabelProps={{
                            shrink: true
                          }}
                          displayEmpty
                        >
                          {gochiUserTypes.map(type => {
                            return (
                              <MenuItem key={type.id} value={type.id}>
                                {type.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    )}

                    <FormControl
                      className={clsx(classes.margin, classes.formControl)}
                      variant="outlined"
                      size="small"
                    >
                      <FormLabel className={classes.subTitle}>
                        購入者名
                      </FormLabel>
                      <TextField
                        placeholder="例) 山田 太郎"
                        type="search"
                        className={classes.textField}
                        variant="outlined"
                        size="small"
                        value={userName}
                        onChange={e => {
                          setUserName(e.target.value);
                        }}
                      />
                    </FormControl>

                    {!isGochiKidGroup && (
                      <FormControl
                        className={clsx(classes.margin, classes.formControl)}
                        variant="outlined"
                        size="small"
                      >
                        <FormLabel className={classes.subTitle}>
                          使用状況
                        </FormLabel>
                        <Select
                          className={classes.textField}
                          variant="outlined"
                          size="small"
                          value={gochiStatus}
                          onChange={e => {
                            setGochiStatus(e.target.value);
                            if (
                              e.target.value === '' ||
                              e.target.value === 'USED'
                            ) {
                              setGochiUseDateEnableFlg(true);
                            } else {
                              setGochiUseDateFrom('');
                              setGochiUseDateTo('');
                              setGochiUseDateEnableFlg(false);
                            }
                          }}
                          InputLabelProps={{
                            shrink: true
                          }}
                          displayEmpty
                        >
                          {gochiStatuses.map(status => {
                            return (
                              <MenuItem key={status.id} value={status.id}>
                                {status.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    )}
                  </>
                )}

                <FormControl
                  className={clsx(
                    classes.margin,
                    isFukuoka ? classes.formControlFukuoka : classes.formControl
                  )}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>
                    使用日 (From)
                  </FormLabel>
                  <TextField
                    type="date"
                    className={classes.textField150}
                    variant="outlined"
                    size="small"
                    InputLabelProps={{
                      shrink: true
                    }}
                    disabled={!gochiUseDateEnableFlg}
                    value={gochiUseDateFrom}
                    onChange={e => {
                      setGochiUseDateFrom(e.target.value);
                    }}
                  />
                </FormControl>

                <FormControl
                  className={clsx(
                    classes.margin,
                    isFukuoka ? classes.formControlFukuoka : classes.formControl
                  )}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>
                    使用日 (To)
                  </FormLabel>
                  <TextField
                    type="date"
                    className={classes.textField150}
                    variant="outlined"
                    size="small"
                    InputLabelProps={{
                      shrink: true
                    }}
                    disabled={!gochiUseDateEnableFlg}
                    value={gochiUseDateTo}
                    onChange={e => {
                      setGochiUseDateTo(e.target.value);
                    }}
                  />
                </FormControl>
                {!isFukuoka && !isGochiKidGroup && (
                  <FormControl
                    className={clsx(classes.margin, classes.formControl)}
                    variant="outlined"
                    size="small"
                  >
                    <FormLabel className={classes.subTitle}>入金予定</FormLabel>
                    <Select
                      className={classes.textField}
                      variant="outlined"
                      size="small"
                      value={depositPlan}
                      onChange={e => {
                        setDepositPlan(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      displayEmpty
                    >
                      {depositPlans.map(plan => {
                        return (
                          <MenuItem key={plan.id} value={plan.id}>
                            {plan.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                )}
              </div>
            </div>
            <div className={classes.buttonLeft}>
              <SearchButton onClickAction={searchAction} />
            </div>
          </Paper>
          {openTable && (
            <div className={classes.pageNButton}>
              <div className={classes.pageLeft}>
                <ExPaginationGroup
                  count={
                    gochis.count % gochis.limit > 0
                      ? Math.floor(gochis.count / gochis.limit) + 1
                      : Math.floor(gochis.count / gochis.limit)
                  }
                  selectedPage={page}
                  handleChangePage={(e, p, l) =>
                    handleChangePage(e, p, l, searchEs)
                  }
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  limit={gochis.limit}
                  totalCount={gochis.count}
                  setLimit={setRowsPerPage}
                />
              </div>
              <div className={classes.buttonRight}>
                {isFukuoka && (
                  <Button
                    variant="outlined"
                    color="primary"
                    style={{ margin: '5px 5px' }}
                    onClick={() => {
                      history.push('/update_amount_history_group');
                    }}
                  >
                    金額修正履歴
                  </Button>
                )}
                {account.fukuokaFlag || isNaha ? (
                  <>
                    <CsvDownloadButton
                      title="検索結果出力（CSV形式）"
                      onClickAction={() => {
                        setIsZip(false);
                        setOpenPopupCsv(true);
                      }}
                    />
                    <CsvDownloadButton
                      title="検索結果出力（ZIP形式）"
                      onClickAction={() => {
                        setIsZip(true);
                        setOpenPopupCsv(true);
                      }}
                    />
                  </>
                ) : (
                  <>
                    <CsvDownloadButton
                      title="検索結果出力（CSV形式）"
                      onClickAction={() => {
                        csvDownloadAction(false);
                      }}
                    />
                    <CsvDownloadButton
                      title="検索結果出力（ZIP形式）"
                      onClickAction={() => {
                        csvDownloadAction(true);
                      }}
                    />
                  </>
                )}
                <div className={classes.textNoteClassicCsv}>
                  ※CSV形式でダウンロードができない場合はZIP形式をお試しください。
                  ZIP形式の説明は
                  <a
                    className={classes.textLinkCsv}
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://shop-guide.gochimeshi.com/group/p16179/"
                  >
                    こちら
                  </a>
                </div>
              </div>
            </div>
          )}
          {openTable && (
            <GochiHistoryTableGroup
              roles={roles}
              page={page}
              handleChangePage={(e, p, l) =>
                handleChangePage(e, p, l, searchEs)
              }
              selectedPage={page}
              searchEs={searchEs}
              isFukuoka={isFukuoka}
              isNaha={isNaha}
              educateSystem={educateSystem}
              openUpdateAmountModal={openUpdateAmountModal}
              openUpdateAmountHistory={openUpdateAmountHistory}
            />
          )}

          {openTable && (
            <div className={classes.pageNButton}>
              <div className={classes.pageLeft}>
                <ExPaginationGroup
                  count={
                    gochis.count % gochis.limit > 0
                      ? Math.floor(gochis.count / gochis.limit) + 1
                      : Math.floor(gochis.count / gochis.limit)
                  }
                  selectedPage={page}
                  handleChangePage={(e, p, l) =>
                    handleChangePage(e, p, l, searchEs)
                  }
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  limit={gochis.limit}
                  totalCount={gochis.count}
                  setLimit={setRowsPerPage}
                />
              </div>
            </div>
          )}
        </main>
        <DownloadCsvDialogConfirm
          message="ダウンロード情報には個人情報が含まれますので、取扱いには十分留意してください"
          openChangeConfirm={openPopupCsv}
          updateOpenChangeConfirm={setOpenPopupCsv}
          cancelAction={cancelCsvAction}
          changeAction={downloadCsvAction}
        />
        <DownloadCsvDialogConfirm
          message="ダウンロード情報には個人情報が含まれますので、取扱いには十分留意してください"
          openChangeConfirm={openPopupESCsv}
          updateOpenChangeConfirm={setOpenPopupESCsv}
          cancelAction={cancelESCsvAction}
          // changeAction={downloadESCsvAction}
        />
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />

        <div>
          <Modal
            open={showUpdateAmountModal}
            className={classes.modalMobile}
            onClose={() => {
              setShowUpdateAmountModal(false);
            }}
          >
            <UpdateAmountModal
              amountUpdated={amountUpdated}
              setAmountUpdated={setAmountUpdated}
              validAmountUpdated={validAmountUpdated}
              amountUpdatedError={amountUpdatedError}
              confirmUpdateAmount={confirmUpdateAmount}
              gochiChoseUpdateAmount={gochiChoseUpdateAmount}
            />
          </Modal>
        </div>

        <div>
          <Modal
            open={showUpdateAmountConfirmModal}
            className={classes.modalMobile}
            onClose={() => {
              backConfirmUpdateAmount();
            }}
          >
            <UpdateAmountConfirmModal
              amountUpdated={amountUpdated}
              editAmountEducationSystem={editAmountEducationSystem}
              backConfirmUpdateAmount={backConfirmUpdateAmount}
              gochiChoseUpdateAmount={gochiChoseUpdateAmount}
              systemNameGochiChoseUpdateAmount={
                systemNameGochiChoseUpdateAmount
              }
              oldAmountUpdateAmount={oldAmountUpdateAmount}
            />
          </Modal>
        </div>

        <div>
          <Modal
            open={showUpdateAmountSuccessModal}
            className={classes.modalMobile}
            onClose={() => {
              handleCloseUpdateAmountSuccessModal();
            }}
          >
            <UpdateAmountSuccessModal
              amountUpdated={amountUpdated}
              gochiChoseUpdateAmount={gochiChoseUpdateAmount}
              handleCloseUpdateAmountSuccessModal={
                handleCloseUpdateAmountSuccessModal
              }
              oldAmountUpdateAmount={oldAmountUpdateAmount}
            />
          </Modal>
        </div>

        <div>
          <Modal
            open={showUpdateAmountHistoryModal}
            className={classes.modalMobile}
            onClose={() => {
              setShowUpdateAmountHistoryModal(false);
            }}
          >
            <UpdateAmountHistoryModal
              setShowUpdateAmountHistoryModal={setShowUpdateAmountHistoryModal}
              updateAmountHistoryDetail={updateAmountHistoryDetail}
            />
          </Modal>
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(HomeGroup)); // <ESSearchButton·onClickAction={searchEsAction} /> <CsvDownloadEsButton onClickAction={csvDownloadEsAction} />
